/*
  Shopify SKU Search Fix
  Add this file to Shopify: Online Store > Themes > Edit code > Assets > Add a new asset
  File name: sku-search-global-patch.js

  Then load it in layout/theme.liquid BEFORE </head> or before </body>:
  <script src="{{ 'sku-search-global-patch.js' | asset_url }}" defer="defer"></script>
*/
(() => {
  const PATCH_FLAG = '__skuSearchGlobalPatchV2Loaded';
  const SKU_SEARCH_FIELDS = 'title,body,product_type,tag,variants.title,vendor,variants.sku,variants.barcode';

  if (window[PATCH_FLAG]) return;
  window[PATCH_FLAG] = true;

  const PREDICTIVE_SEARCH_PATH_RE = /\/search\/suggest(?:\.json)?\/?$/;
  const NORMAL_SEARCH_PATH_RE = /\/search(?:\.json)?\/?$/;

  function safeUrl(rawUrl) {
    try {
      return new URL(rawUrl, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function mergeCommaParam(url, paramName, valuesToAdd) {
    const currentValue = url.searchParams.get(paramName) || '';
    const currentValues = currentValue
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

    valuesToAdd.forEach((value) => {
      if (!currentValues.includes(value)) currentValues.push(value);
    });

    url.searchParams.set(paramName, currentValues.join(','));
  }

  function patchSearchUrl(rawUrl) {
    const url = safeUrl(rawUrl);
    if (!url) return rawUrl;

    const pathname = url.pathname;

    if (PREDICTIVE_SEARCH_PATH_RE.test(pathname)) {
      mergeCommaParam(url, 'resources[type]', ['product']);
      url.searchParams.set('resources[options][fields]', SKU_SEARCH_FIELDS);
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      return url.toString();
    }

    if (NORMAL_SEARCH_PATH_RE.test(pathname)) {
      mergeCommaParam(url, 'type', ['product']);
      url.searchParams.set('options[fields]', SKU_SEARCH_FIELDS);
      url.searchParams.set('options[unavailable_products]', 'last');
      url.searchParams.set('options[prefix]', 'last');
      return url.toString();
    }

    return rawUrl;
  }

  function ensureHiddenInput(form, name, value) {
    if (!form) return;

    let input = Array.from(form.elements || []).find((field) => field.name === name);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function looksLikeSearchForm(form) {
    if (!form || form.nodeType !== 1) return false;

    const action = form.getAttribute('action') || '';
    const role = form.getAttribute('role') || '';
    const hasSearchInput = Boolean(form.querySelector('input[type="search"], input[name="q"]'));

    return action.includes('/search') || role.toLowerCase() === 'search' || hasSearchInput;
  }

  function patchSearchForm(form) {
    if (!looksLikeSearchForm(form)) return;

    ensureHiddenInput(form, 'type', 'product');
    ensureHiddenInput(form, 'options[fields]', SKU_SEARCH_FIELDS);
    ensureHiddenInput(form, 'options[unavailable_products]', 'last');
    ensureHiddenInput(form, 'options[prefix]', 'last');
  }

  function patchAllSearchForms(root = document) {
    if (!root || !root.querySelectorAll) return;

    root
      .querySelectorAll('form[action*="/search"], form[role="search"], form:has(input[type="search"]), form:has(input[name="q"])')
      .forEach(patchSearchForm);
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__skuSearchPatched) return;

    const originalFetch = window.fetch.bind(window);

    const patchedFetch = function skuSearchPatchedFetch(input, init) {
      try {
        if (typeof input === 'string' || input instanceof URL) {
          return originalFetch(patchSearchUrl(input.toString()), init);
        }

        if (input instanceof Request) {
          const patchedUrl = patchSearchUrl(input.url);
          if (patchedUrl !== input.url) {
            return originalFetch(new Request(patchedUrl, input), init);
          }
        }
      } catch (error) {
        return originalFetch(input, init);
      }

      return originalFetch(input, init);
    };

    patchedFetch.__skuSearchPatched = true;
    window.fetch = patchedFetch;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.open.__skuSearchPatched) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;

    function patchedOpen(method, url, ...rest) {
      const patchedUrl = typeof url === 'string' ? patchSearchUrl(url) : url;
      return originalOpen.call(this, method, patchedUrl, ...rest);
    }

    patchedOpen.__skuSearchPatched = true;
    window.XMLHttpRequest.prototype.open = patchedOpen;
  }

  function init() {
    patchFetch();
    patchXhr();
    patchAllSearchForms();
  }

  init();

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener(
    'submit',
    (event) => {
      patchSearchForm(event.target);
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    patchAllSearchForms(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches?.('form')) patchSearchForm(node);
        patchAllSearchForms(node);
      });
    });
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
